import AutoWebSocket from './lib/auto-websocket'
import store from './store'

/* eslint no-new: 0 */

new AutoWebSocket('eu.nosconte.infobits', dispatcher)

function dispatcher (message) {
  store.dispatch('_' + message.command, message)
}



// WEBPACK FOOTER //
// ./src/websocket.js